import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import notify from 'devextreme/ui/notify';

@Injectable({
  providedIn: 'root'
})
export class SignalRDocService {
  private hubConnection: signalR.HubConnection;
  public statusUpdate$ = new Subject<any>();

  constructor() { }

  public initConnection(userId: string) {

    const baseUrl = environment.apiRoot.replace('/api', '');

    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${baseUrl}/invoiceHub`, {
        accessTokenFactory: () => localStorage.getItem('token') || '',
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets
      })
      .withAutomaticReconnect()
      .build();

    this.hubConnection
      .start()
      .then(() => {
        console.log('SignalR Connected.');
        this.hubConnection.invoke('JoinUserGroup', userId);
      })
      .catch(err => console.log('SignalR Error: ' + err));

    // استقبال التحديث
    this.hubConnection.on('ReceiveStatusUpdate', (data) => {
      // 1. نذيع الخبر للـ Components (عشان الجريد يتحدث)
      this.statusUpdate$.next(data);

      // 2. نظهر النوتيفيكشن الرايقة في الجنب
      this.showToast(data);
    });
  }

  private showToast(data: any) {
    console.log("البيانات المستلمة:", data);

    const isSuccess = data.newStatus == 1 || data.statusName?.toLowerCase() === 'valid';

    const type = isSuccess ? 'success' : 'error';
    const icon = isSuccess ? 'check' : 'warning';
    const title = isSuccess ? 'تم قبول الفاتورة' : 'تم رفض الفاتورة';

    notify({
      message: '',
      type: type,
      displayTime: 10000,
      position: { at: "top right", my: "top right", offset: "-20 20" },
      width: 380,
      contentTemplate: (element: HTMLElement) => {
        const container = document.createElement("div");
        container.classList.add("custom-toast-container");
        container.innerHTML = `
                <div style="display: flex; align-items: center; gap: 15px; color: white;">
                    <i class="dx-icon-${icon}" style="font-size: 24px;"></i>
                    <div style="flex-grow: 1;">
                        <div style="font-weight: bold; font-size: 14px;">${title}</div>
                        <div style="font-size: 12px;">رقم الفاتوره: <b>${data.internalId}</b></div>
                    </div>
                </div>
            `;
        element.appendChild(container);
      }
    }, {
      direction: 'down-push'
    });
  }
}